/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */

import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IAgentChipList } from '../../interfaces/IAgentChatInterface';
import { ChatContent, ChatMessage } from '../../models/chat.model';
import { AIAgentService } from '../../services/ai-agent.service';
// import { SearchData } from './../../../connectivity/_models/Connectivity';
import { SearchResultModal } from '../../../global-search-filters/contracts/modal';
import { AIAgentDefaultChipList } from '../../constant/ai-agent.constant';
import { SearchInputData } from '../../constant/search-input.config';
import { LocalCacheService } from '../../../../core/local-cache/local-cache.service';
import { ChatHistoryListComponent } from '../chat-history-list/chat-history-list.component';
@Component({
    selector: 'nalco-ai-agent',
    templateUrl: './ai-agent-bot.component.html',
    styleUrls: ['./ai-agent-bot.component.scss'],
    standalone: false
})
export class AIAgentComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChild('messageInput') messageInput!: ElementRef;
  @ViewChild('chatHistoryList') chatHistoryList: ChatHistoryListComponent;
  @ViewChild('siteSearchBar') public siteSearchBar!: ElementRef;
  @Input() calledFromFsqs: boolean = false;

  // messages: ChatMessage[] = [];
  messages = [];
  currentMessage: string = '';
  isLoading: boolean = false;
  sendingRequest: boolean = false;
  isConnected: boolean = true;
  contextPointId: number | null = null;

  private destroy$ = new Subject<void>();
  chatSubscription$: Subscription
  selectedSearchResult: SearchResultModal;
  searchResultModal: SearchResultModal;
  public searchCounts = {
    corporateAccountCount: 5,
    siteCount: 5
  }
  private recognition: any;
  isRecording: boolean = false;
  voiceSupported: boolean = false;
  microphonePermission: string = 'prompt'; // 'granted', 'denied', 'prompt'
  placeHolderMessage: string;
  private recordingTimeout: any; // Add timeout tracking

  // Textarea auto-resize properties
  private minTextareaHeight = 40; // 2.5rem converted to px
  private maxTextareaHeight = 96; // 6rem converted to px
  noInput: boolean = false;

  chipList: IAgentChipList[] = AIAgentDefaultChipList;
  // defaultNavigationLists: IDefaultNavigationLink[] = [];
  feedBackSelected: { messageId: string, didUserLike: boolean | null, feedBack: string } = { messageId: '', didUserLike: null, feedBack: '' };

  agentProcessingMessage = "Let me check that for you...";
  searchInputData: any;

  // Edit message properties
  editMessageId: string | null = null;
  editingMessage: string = '';
  showAIAgent = false;

  // Search dropdown properties
  displaySearch: boolean = false;
  isSearchDropDownDisable: boolean = false;
  selectedSearchDetails: any = { name: null };
  chatID: string | null;

  // Context Point Details Cache
  private contextPointCache: { [contextPointId: string]: { contextPointId: number, siteName: string } } = {};
  isLoadingChat: boolean;
  enableChatStreaming = false;
  constructor(
    private aiAgentService: AIAgentService,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private localCacheService: LocalCacheService
  ) { }

  /**
   * Get placeholder message based on error state
   */
  get currentPlaceholder(): string {
    return this.noInput ? 'Please input query to continue' : this.placeHolderMessage;
  }

  ngOnInit() {
    this.placeHolderMessage = 'Ask me anything..!';
    this.chatID = null;
    //   this.chipList = [
    //   { name: 'Water Quality overview', value: 'Give details about water quality?', iconUrl: '' },
    // ]
    this.searchInputData = JSON.parse(JSON.stringify(SearchInputData))
    this.setupVoiceRecognition();
    this.checkMicrophonePermission();
     if (this.calledFromFsqs && this.messages.length === 0) {
      this.initializeChat();
    }

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    // Clean up speech recognition
    if (this.recognition && this.isRecording) {
      this.isRecording = false;
      this.recognition.stop();
    }

    // Clear any pending timeouts
    if (this.recordingTimeout) {
      clearTimeout(this.recordingTimeout);
    }

    // Clear context point cache on component destroy
    this.clearContextPointCache();
  }

  ngAfterViewChecked() {
    // this.scrollToBottom();
  }

  private initializeChat() {
    let name = this.localCacheService.fetchData('User_FirstName', 'local');
    let greeting = this.getTimeBasedGreeting();

    // Add welcome message
    this.messages = [];
    this.chatID = crypto.randomUUID();
    const welcomeMessage: ChatMessage = {
      id: '',
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `<strong>${greeting},${name ? ' ' + name : ''}.</strong>! ${this.translate.instant(this.calledFromFsqs ? 'AI_AGENT.FSIQ_WELCOME_MESSAGE' : 'AI_AGENT.AGENT_WELCOME_MESSAGE')} <br/> <span style="color: #313233">${this.translate.instant(this.calledFromFsqs ? 'AI_AGENT.FSIQ_HELP_QUESTION' : 'AI_AGENT.HELP_QUESTION')}</span>`
      }
    };
    this.messages.push(welcomeMessage);

    this.chipList = [
      { name: 'What permissions do I have', value: 'What permissions do I have', iconUrl: '' },
      { name: 'Show my preferences', value: 'Show my preferences', iconUrl: '' },
      { name: 'Who is the account owner', value: 'Who is the account owner', iconUrl: '' },
      { name: 'Show open action logs at this site', value: 'Show open action logs at this site', iconUrl: '' },
      { name: 'Unmapped (active) data sources at this site', value: 'Unmapped data sources at this site', iconUrl: '', /** navigationLink: `#/assetharvester/siteOverview/${this.contextPointId}/siteView`, navigationDisplayName: 'Open Asset Harvester' */ },
      { name: 'WQ assets needing attention', value: 'WQ assets needing attention (red assets)', iconUrl: '', /** navigationLink: `#/water-quality-iq/siteView/${this.contextPointId}`, navigationDisplayName: 'Open Water Quality for Site' */ },
      { name: 'What are my E-Data Sub-Configurations', value: 'What are my E-Data Sub-Configurations', iconUrl: '' },
      { name: 'Show me the available inventory serial numbers which are not mapped to any asset', value: 'Show me the available inventory serial numbers which are not mapped to any asset', iconUrl: '' },
      { name: 'Give me the default SSD dashboard for this site', value: 'Give me the default SSD dashboard for this site', iconUrl: '' }
    ];

    //  this.defaultNavigationLists = [
    //    { name: 'Open Asset Harvester', value: 'Open Asset Harvester', iconUrl: '', link: `#/assetharvester/siteOverview/${this.contextPointId}/siteView` },
    //    { name: 'Open Water Quality for Site', value: 'Open Water Quality for Site', iconUrl: '', link: `#/water-quality-iq/siteView/${this.contextPointId}` },
    //  ];
  }

  sendMessage(editMessageId?: string) {
    this.scrollToBottom();
    this.noInput = !this.currentMessage?.trim().length;
    this.enableChatStreaming = true;
    if (!this.currentMessage?.trim() || this.isLoading) {
      this.currentMessage = '';
      return;
    }

    this.sendingRequest = true;
    const userMessage: ChatMessage = {
      id: editMessageId ? editMessageId : this.generateId(),
      type: 'user',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: this.currentMessage
      }
    };

    this.messages.push(userMessage);
    const messageToSend = this.currentMessage;
    this.currentMessage = '';
    this.isLoading = true;

    // Reset textarea height after clearing message
    setTimeout(() => {
      const textarea = document.getElementById('ask-label') as HTMLTextAreaElement;
      if (textarea) {
        textarea.style.height = this.minTextareaHeight + 'px';
      }
    }, 0);

    // Determine chatId to send:
    // - For new chats: send empty string
    // - For existing chats: send current chatID
    // - For edited messages: send current chatID (continue same conversation)
    const chatIdToSend = this.chatID || '';

    // Send message to chat service
    const sendApi$ = this.calledFromFsqs
      ? this.aiAgentService.sendFsqsMessage(messageToSend, chatIdToSend)
      : this.aiAgentService.sendMessage(messageToSend, this.contextPointId ?? 0, chatIdToSend);

    this.chatSubscription$ = sendApi$
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        // For FSQS, keep the UUID generated upfront; for others, take chatID from response
        if (!this.calledFromFsqs) {
          this.chatID = response?.ChatId;
        }

        const botMessage: ChatMessage = {
          id: response.ChatId,
          type: 'bot',
          timestamp: new Date(),
          content: this.parseResponse(response)// response.Response //this.parseResponse(response)
        };
        const resMes = { content: botMessage.content };
        this.messages.push(botMessage);
        this.isLoading = false;
        this.sendingRequest = false;
        // Need to handle the resetting of feedback
        this.feedBackSelected = { messageId: botMessage.id, didUserLike: null, feedBack: '' };
        this.scrollToBottom();
      },
        (error) => {
          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while processing your request. Please try again.'
            }
          };
          this.messages.push(errorMessage);
          this.isLoading = false;
          this.sendingRequest = false;
          this.scrollToBottom();
        }

      );
  }

  onKeyPress(event: any, messageId: string) {
    if (this.isRecording) {
      this.recognition.stop();
    }

    // Handle edit mode key presses
    if (this.editMessageId) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        // this.currentMessage = event?.target?.value;
        this.saveEditedMessage();
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.cancelEdit();
        return;
      }
    } else {
      // Normal message input mode
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    }

    // Auto-adjust textarea height after key press
    setTimeout(() => {
      const textarea = event.target as HTMLTextAreaElement;
      this.adjustTextareaHeight(textarea);
    }, 0);
  }

  /**
   * Handle textarea input for auto-resize and error state
   */
  onTextareaInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    this.adjustTextareaHeight(textarea);

    // Clear error state when user starts typing
    if (this.noInput) {
      this.noInput = false;
    }
  }

  /**
   * Auto-adjust textarea height based on content
   */
  private adjustTextareaHeight(textarea: HTMLTextAreaElement): void {
    if (!textarea) return;

    // Reset height to auto to calculate scroll height
    textarea.style.height = 'auto';

    const scrollHeight = textarea.scrollHeight;
    const newHeight = Math.min(Math.max(scrollHeight, this.minTextareaHeight), this.maxTextareaHeight);

    textarea.style.height = newHeight + 'px';

    // Show scrollbar if content exceeds max height
    if (scrollHeight > this.maxTextareaHeight) {
      textarea.style.overflowY = 'auto';
    } else {
      textarea.style.overflowY = 'hidden';
    }
  }

  private parseResponse(response: any): ChatContent {
    // Handle different response types from backend
    try {
      if (this.calledFromFsqs && response?.Messages?.[0]?.content) {
        return { type: 'text', data: response.Messages[0].content };
      }

      if (typeof response.Response === 'string') {
        return { type: 'text', data: response.Response };
      }

      if (response.type) {
        return response as ChatContent;
      }

      // Auto-detect response type
      if (Array.isArray(response)) {
        return {
          type: 'list',
          data: { type: 'unordered', items: response },
          metadata: { title: 'Results' }
        };
      }

      if (typeof response === 'object') {
        // Check if it's a table structure
        if (response.headers && response.rows) {
          return {
            type: 'table',
            data: response,
            metadata: { title: response.title || 'Data Table' }
          };
        }

        // Check if it's code
        if (response.code && response.language) {
          return {
            type: 'code',
            data: response.code,
            metadata: { language: response.language }
          };
        }

        // Default to text representation
        response.choices = response.choices[0].message.content || ""
        return {
          type: 'text',
          data: JSON.stringify(response, null, 2)
        };
      }

      return { type: 'text', data: String(response) };

    } catch (error) {
      return {
        type: 'text',
        data: 'Error parsing response from server.'
      };
    }
  }

  private generateId(): string {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  /**
   * Get time-based greeting based on current hour
   */
  private getTimeBasedGreeting(): string {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return this.translate.instant('AI_AGENT.GOOD_MORNING');
    } else if (currentHour >= 12 && currentHour < 17) {
      return this.translate.instant('AI_AGENT.GOOD_AFTERNOON');
    } else if (currentHour >= 17 && currentHour < 21) {
      return this.translate.instant('AI_AGENT.GOOD_EVENING');
    } else {
      return this.translate.instant('AI_AGENT.HELLO');
    }
  }

  private scrollToBottom(delay = 50): void {
    setTimeout(() => {
      try {
        const element = this.chatContainer?.nativeElement;
        if (element) {
          element.scrollTop = element.scrollHeight;
        }
      } catch (err) {
      }
    }, delay);
  }

  // Utility methods for template
  isUserMessage(message: ChatMessage): boolean {
    return message.type === 'user';
  }

  isBotMessage(message: ChatMessage): boolean {
    return message.type === 'bot';
  }

  formatTimestamp(timestamp: Date): string {
    return new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    }).format(timestamp);
  }

  trackByMessageId(index: number, message: ChatMessage): string {
    return message.id;
  }

  public getSelectedSiteData($event: any): void {
    this.selectedSearchDetails = $event?.selectedSearchedResult;
    this.contextPointId = $event?.selectedSearchedResult?.SiteId;
    this.searchResultModal = $event;
    this.displaySearch = false; // Close the search dropdown
    this.initializeChat();
  }

  /**
 * Toggle voice recording - start if not recording, stop if recording
 */
  toggleRecording(): void {
    if (this.isRecording) {
      this.stopRecording();
    } else {
      this.startRecording();
    }
  }

  /**
   * Prevent event bubbling to parent flyout
   */
  public preventEventBubbling(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
  }

  /**
   * Toggle search dropdown visibility
   */
  toggleSearchDropdown(): void {
    if (!this.isSearchDropDownDisable) {
      this.displaySearch = !this.displaySearch;
    }
  }

  /**
* Handles the clear selection event from the global search filters component.
* When triggered, this method resets the component to its default state by:
* - Clearing the selected search result modal
* - Resetting all filter chips to their default values
* - Emitting null to notify parent components of the cleared selection
*
* @param {boolean} $event - Flag indicating whether the clear selection action should be executed.
*                          When true, performs the clear operation; when false, no action is taken.
* @returns {void}
*/
  public clearSelection($event: boolean): void {
    if ($event) {
      this.searchResultModal = null;
      this.contextPointId = null;
    }
  }

  onChipSelection(selectedChip: IAgentChipList) {
    this.currentMessage = selectedChip.value;
    this.sendMessage();
  }


  private async checkMicrophonePermission(): Promise<void> {
    if ('navigator' in window && 'permissions' in navigator) {
      try {
        const permission = await navigator.permissions.query({ name: 'microphone' as PermissionName });
        this.microphonePermission = permission.state;

        // Listen for permission changes
        permission.addEventListener('change', () => {
          this.microphonePermission = permission.state;
        });

      } catch (error) {
      }
    }
  }

  /**
   * Request microphone permission explicitly
   */
  private async requestMicrophonePermission(): Promise<boolean> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Stop the stream immediately as we only wanted permission
      stream.getTracks().forEach(track => track.stop());
      this.microphonePermission = 'granted';
      return true;
    } catch (error) {
      this.microphonePermission = 'denied';
      this.showPermissionError();
      return false;
    }
  }

  /**
     * Setup speech recognition with permission handling
     */
  private setupVoiceRecognition(): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

    if (SpeechRecognition) {
      this.voiceSupported = true;
      this.recognition = new SpeechRecognition();

      // Configure settings for continuous recording
      this.recognition.continuous = true;  // Keep listening continuously
      this.recognition.interimResults = true;  // Show real-time results
      this.recognition.lang = 'en-US';
      this.recognition.maxAlternatives = 1;  // Only need the best result

      // Event handlers - SET ONCE HERE
      this.recognition.onstart = () => {
        this.isRecording = true;
      };

      this.recognition.onresult = (event: any) => {
        let finalTranscript = '';
        let interimTranscript = '';

        // Process all results
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;

          if (event.results[i].isFinal) {
            finalTranscript += transcript + ' ';
          } else {
            interimTranscript += transcript;
          }
        }

        // Update UI with current speech
        if (finalTranscript) {
          this.currentMessage = (this.currentMessage + finalTranscript).trim();
          this.sendMessage();
        }

        // Show interim results as placeholder only
        if (interimTranscript) {
          this.updatePlaceholderMessage(`Hearing: "${interimTranscript}"`);
        }
      };

      this.recognition.onend = () => {
        // If we're supposed to be recording (user still holding button), restart
        if (this.isRecording) {
          // Restart recognition after a brief pause
          setTimeout(() => {
            if (this.isRecording) {
              try {
                this.recognition.start();
              } catch (error) {
                this.handleSpeechError('restart-failed');
              }
            }
          }, 100);
        } else {
          // User stopped recording - reset to default placeholder
          this.updatePlaceholderMessage('Ask me anything..!');
        }
      };

      this.recognition.onerror = (event: any) => {
        this.isRecording = false;
        // Reset to default placeholder on error
        this.updatePlaceholderMessage('Ask me anything..!');
      };
    } else {
    }
  }

  /**
   * Toggle voice recording with permission checks
   */
  async startRecording(): Promise<void> {
    if (!this.voiceSupported) {
      alert('Voice recognition not supported in this browser');
      return;
    }

    // If already recording, stop it
    if (this.isRecording) {
      this.recognition.stop();
      return;
    }

    // Check/request permission before starting
    if (this.microphonePermission === 'denied') {
      this.showPermissionError();
      return;
    }

    if (this.microphonePermission === 'prompt') {
      const granted = await this.requestMicrophonePermission();
      if (!granted) return;
    }

    try {
      // Clear previous message if starting fresh
      if (!this.currentMessage.trim()) {
        this.currentMessage = '';
      }

      // Start continuous recognition
      this.recognition.start();
    } catch (error) {
      this.handleSpeechError('start-failed');
    }
  }

  stopRecording() {
    if (this.isRecording) {
      this.isRecording = false; // Set this BEFORE calling stop() so onend knows it was intentional

      // Clear any pending restart timeout
      if (this.recordingTimeout) {
        clearTimeout(this.recordingTimeout);
        this.recordingTimeout = null;
      }

      this.recognition.stop(); // This will trigger onend which resets placeholder
    }
  }

  /**
   * Handle speech recognition errors
   */
  private handleSpeechError(error: string): void {
    let message = '';

    switch (error) {
      case 'not-allowed':
        message = 'Microphone access denied. Please allow microphone permissions in your browser settings.';
        break;
      case 'no-speech':
        message = 'No speech detected. Please speak clearly and try again.';
        break;
      case 'network':
        message = 'Network error occurred. Please check your internet connection.';
        break;
      case 'audio-capture':
        message = 'No microphone found. Please check your audio devices.';
        break;
      case 'start-failed':
        message = 'Failed to start voice recognition. Please try again.';
        break;
      case 'restart-failed':
        message = 'Voice recognition stopped unexpectedly. Please click the microphone again.';
        break;
      default:
        message = 'Voice recognition failed. Please try again.';
    }

    // Show error message to user
    this.addSystemMessage(message, 'error');
  }

  /**
     * Show permission error with instructions
     */
  private showPermissionError(): void {
    const message = `
            🎤 Microphone access is required for voice input.
            
            To enable:
            1. Click the microphone icon in your browser's address bar
            2. Select "Always allow" for this site
            3. Try the voice button again
        `;

    this.addSystemMessage(message, 'error');
  }

  /**
   * Update placeholder message with change detection
   */
  private updatePlaceholderMessage(message: string): void {
    this.placeHolderMessage = message;
    this.cdr.detectChanges();
  }

  /**
   * Add system message to chat
   */
  private addSystemMessage(text: string, type: 'info' | 'error' = 'info'): void {
    const systemMessage: ChatMessage = {
      id: this.generateId(),
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `${type === 'error' ? '⚠️' : 'ℹ️'} ${text}`
      }
    };
    this.messages.push(systemMessage);
    this.scrollToBottom();
  }

  clearMessage() {
    this.currentMessage = '';

    // Reset textarea height
    setTimeout(() => {
      const textarea = document.getElementById('ask-label') as HTMLTextAreaElement;
      if (textarea) {
        textarea.style.height = this.minTextareaHeight + 'px';
      }
    }, 0);
  }

  startNewChat() {
    this.messages = [];
    this.chatID = this.calledFromFsqs ? crypto.randomUUID() : null;
    this.currentMessage = '';
    if (this.calledFromFsqs) {
      this.initializeChat();
    }
  }

  sendFeedback(messageId: string, didUserLike: boolean) {
    // // Need to access MessageId instaed of message
    // const existingFeeback = this.feedBackSelected.find(fb => fb.messageId === messageId);
    // if (existingFeeback) {
    //   existingFeeback.didUserLike = didUserLike;
    // } else {
    //   this.feedBackSelected.push({messageId: messageId, didUserLike: didUserLike, feedBack: ''});
    // }
    this.feedBackSelected = { messageId: messageId, didUserLike: didUserLike, feedBack: '' };
  }

  openAIAgent() {
    this.showAIAgent = !this.showAIAgent;
    if (this.showAIAgent) {
      this.scrollToBottom(350);
    }
  }

  /**
   * Enable edit mode for a user message
   */
  enableMessageEdit(messageId: string): void {
    const message = this.messages.find(msg => msg.id === messageId);
    if (message && message.type === 'user' && this.editMessageId !== messageId) {
      this.editMessageId = messageId;
      this.editingMessage = message.content.data;

      // Focus the textarea after Angular renders it
      setTimeout(() => {
        const editTextarea = document.querySelector('.edit-textarea') as HTMLTextAreaElement;
        if (editTextarea) {
          editTextarea.focus();
          // editTextarea.select();
        }
      }, 0);
    }
  }

  /**
   * Save the edited message and remove user message + next bot message
   */
  saveEditedMessage(): void {
    if (!this.editMessageId || !this.editingMessage.trim()) {
      return;
    }

    // Find the index of the message being edited
    const messageIndex = this.messages.findIndex(msg => msg.id === this.editMessageId);
    if (messageIndex === -1) {
      return;
    }

    // Remove the user message and the next bot message (if it exists)
    const messagesToRemove = 1; // Remove the user message
    let removeCount = messagesToRemove;

    // Check if there's a bot message immediately after this user message
    if (messageIndex + 1 < this.messages.length &&
      this.messages[messageIndex + 1].type === 'bot') {
      removeCount = 2; // Remove both user and bot message
    }

    // Remove the messages
    this.messages.splice(messageIndex, removeCount);

    // Create new user message with edited content
    // const newUserMessage: ChatMessage = {
    //   id: this.editMessageId,
    //   type: 'user',
    //   timestamp: new Date(),
    //   content: {
    //     type: 'text',
    //     data: this.editingMessage.trim()
    //   }
    // };

    // Insert the new message at the same position
    // this.messages.splice(messageIndex, 0, newUserMessage);



    // Send the new message to get a fresh response
    this.currentMessage = this.editingMessage.trim();
    this.sendMessage(this.editMessageId);

    // Reset edit state
    this.cancelEdit();
  }

  /**
   * Cancel edit mode without saving changes
   */
  cancelEdit(): void {
    this.editMessageId = null;
    this.editingMessage = '';
  }

  /**
     * Handle chat history selection from flyout component
     * Sets the chatID for continuing an existing conversation
     */
  onChatHistorySelected(historyItem: any): void {
    // Set the chatID to continue the existing conversation
    this.chatID = historyItem?.id;
    this.isLoadingChat = true;
    this.enableChatStreaming = false;

    this.getContexPointDetails(historyItem?.ContextIdentifier?.Value);

    this.aiAgentService.getChatHistory(historyItem?.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((chatHistory) => {

        this.messages = [];

        // Convert chat history messages to the format used by this.messages
        if (chatHistory && chatHistory.messages && Array.isArray(chatHistory.messages)) {
          const convertedMessages: ChatMessage[] = chatHistory.messages
            .map((msg: any) => {
              return {
                id: this.generateId(),
                type: msg.role === 'Assistant' ? 'bot' : 'user',  //Map role to type
                timestamp: msg.timestamp ? new Date(msg.timestamp) : new Date(),
                content: msg.role === 'Assistant' ? this.parseResponse(msg.content) : {
                  type: 'text',
                  data: msg.content || ''
                }
              };
            })
            .reverse(); // Backend sends newest-first, we want oldest-first for chat display
          // Set the converted messages to this.messages
          this.messages = convertedMessages;
          // Scroll to bottom to show the loaded chat
          this.scrollToBottom();
        }
        this.isLoadingChat = false;
      }, (_error?) => {
        this.isLoadingChat = false;
      }
      );
  }

  public closeAgentFlyout(showAIAgent: boolean): void {
    this.showAIAgent = showAIAgent;
  }

  getContexPointDetails(contextPointID: string) {
    // Check if we already have this context point cached
    if (this.contextPointCache[contextPointID]) {

      // Use cached data
      setTimeout(() => {
        this.searchInputData.SearchTabs[1].activeData = {
          contextPointId: this.contextPointCache[contextPointID].contextPointId,
          contextPointName: this.contextPointCache[contextPointID].siteName,
          selectionHierarchy: [],
        };
        this.selectedSearchDetails.Site = this.contextPointCache[contextPointID].siteName;
        this.contextPointId = this.contextPointCache[contextPointID].contextPointId;
      }, 0);

      return; // Exit early, no API call needed
    }

    // If not cached, make API call
    const contextPointId = [Number(contextPointID)];
    this.aiAgentService.getsitesByCorporate(contextPointId).pipe(takeUntil(this.destroy$)).subscribe((contextPointDetail) => {
      if (contextPointDetail && contextPointDetail[0]) {

        // Cache the context point details for future use
        this.contextPointCache[contextPointID] = {
          contextPointId: contextPointDetail[0]?.ContextPointId,
          siteName: contextPointDetail[0]?.SiteName
        };


        setTimeout(() => {
          this.searchInputData.SearchTabs[1].activeData = {
            contextPointId: contextPointDetail[0]?.ContextPointId,
            contextPointName: contextPointDetail[0]?.SiteName,
            selectionHierarchy: [],
          };
          this.selectedSearchDetails.Site = contextPointDetail[0]?.SiteName;
          this.contextPointId = contextPointDetail[0]?.ContextPointId;
          this.isLoadingChat = false;
        }, 0);
      } else {
        this.contextPointId = Number(contextPointID);
        this.isLoadingChat = false;
      }
    }, (_error) => {
      this.isLoadingChat = false;
    });
  }

  /**
   * Clear context point cache - useful for testing or when data needs refreshing
   */
  clearContextPointCache(): void {
    this.contextPointCache = {};
  }

  /**
   * Get cached context point details without making API call
   */
  getCachedContextPointDetails(contextPointID: string): { contextPointId: number, siteName: string } | null {
    return this.contextPointCache[contextPointID] || null;
  }

  onToggleRightPanel(showRightPanel: boolean) {
    if (showRightPanel) {
      this.chatHistoryList.getChatHistoryList();
    }
  }

}

